// Module
var code = "<nav3-menu> <nav3-menu-col> <nav3-menu-item id=\"library-nav-dropdown-item\" state=\"library.team-media\" text=\"Library\" upsell-modal=\"media.library\"></nav3-menu-item> <nav3-menu-item id=\"share-nav-dropdown-item\" state=\"syndication.summary\" text=\"Share\"></nav3-menu-item> </nav3-menu-col> </nav3-menu> ";
// Exports
module.exports = code;